module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "kbx-form-footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showButton()),
      expression: "showButton()"
    }],
    staticClass: "kbx-btn",
    staticStyle: {
      "min-width": "100px",
      "overflow": "visible"
    },
    style: (_vm.stepStyle('button')),
    attrs: {
      "klickbox-edit-item": "button",
      "klickbox-edit-label": "Botão Próximo",
      "klickbox-edit-label": _vm.$t('edit.canvas.next_button'),
      "klickbox-internal-style": "kbx-btn-submit-form"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.stepPreview.next_button_text || _vm.$t('general.labels.next')) + "\n  ")])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-c30d64d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/ButtonNext.vue
 ** module id = 906
 ** module chunks = 1
 **/